import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { Tools } from '../../../core/utils/tools';

@Component({
    selector: 'sl-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaComponent implements OnInit {
    @Input() tagId?: string;
    @Input() type = 'text';
    @Input() isDisabled = false;
    @Input() hasFloatingLabel = false;
    @Input() placeholderKey: string;
    @Input() inputPlaceholderKey: string;
    @Input() control: AbstractControl;
    @Input() minLength?: number;
    @Input() maxLength?: number;
    @Input() inputSize?: number;
    @Input() customStyle?: object;
    @Input() heightRows?: number;

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() readonly blur = new EventEmitter<void>();
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() readonly input = new EventEmitter<any>();

    ngOnInit(): void {
        if (!this.tagId) {
            this.tagId = Tools.Utils.newGuid();
        }
    }

    onBlur(): void {
        this.blur.emit();
    }

    onInput(event: any): void {
        this.input.emit(event);
    }
}
